/*
  BSF-CUSTOM · openai-ads-attribution · 2026-09-30 (Brad). Companion to snippets/bsf-oai-pixel.liquid;
  full design in BootstrapFarmer-master Dev/OpenAiAds.md.

  1. Copies the OpenAI Pixel's first-party cookies into cart attributes so they reach the order:
       __oppref (ad-click id, 30d) -> _oai_oppref     __obref (browser ref, 365d) -> _oai_obref
     plus _oai_consent = "1"/"0". BSF.ApiServer reads them off the order and sends order_created
     server-side; the Conversions API cannot see cookies, and it skips the order when _oai_consent is "0".
     The underscore hides them from the shopper at checkout. Acts only on an explicit consent answer from
     the pixel snippet; writes only when the cart has items and a value changed.
  2. Fires items_added (every /cart/add.js, including the cart-page upsell) and checkout_started (the
     cart page and mini-cart checkout buttons). Express buttons (Shop Pay / PayPal) skip both; the
     checkout Custom Pixel covers their attribution (Dev/OpenAiAds.md).
  House pattern, same as bsf-cart-upsell.js: jQuery ajaxComplete on /cart URLs, with a selfUpdate guard.
  No group_id in contents: "Conversions API only ... not supported by the JavaScript Pixel".
*/
(function () {
  'use strict';
  if (!window.jQuery) return;
  var $ = window.jQuery;

  var COOKIES = { __oppref: '_oai_oppref', __obref: '_oai_obref' };
  var CONSENT_ATTR = '_oai_consent';
  var selfUpdate = false;
  var lastCart = null;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function consent() { return window.__bsfOaiConsent; } // true | false | undefined (not answered yet)
  function measure() {
    if (typeof window.oaiq !== 'function' || consent() !== true) return;
    window.oaiq.apply(null, arguments);
  }
  function cookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    if (!m) return '';
    try { return decodeURIComponent(m[1]); } catch (e) { return m[1]; }
  }
  function currency(cart) {
    return (cart && cart.currency) || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  }
  function contentOf(item, cur) {
    return {
      id: String(item.variant_id), name: item.product_title || item.title,
      content_type: 'product', quantity: item.quantity, amount: item.final_price, currency: cur
    };
  }

  // Keep _oai_* in step with the cookies and the consent answer (blanked when consent is off).
  function syncAttributes(cart) {
    var c = consent();
    if (c === undefined || !cart || !cart.item_count) return;
    var current = cart.attributes || {};
    var want = {};
    Object.keys(COOKIES).forEach(function (k) { want[COOKIES[k]] = c ? cookie(k) : ''; });
    want[CONSENT_ATTR] = c ? '1' : '0';
    var changes = {};
    Object.keys(want).forEach(function (a) { if ((current[a] || '') !== want[a]) changes[a] = want[a]; });
    if (!Object.keys(changes).length) return;
    selfUpdate = true;
    $.ajax({
      type: 'POST', url: root() + 'cart/update.js', dataType: 'json',
      contentType: 'application/json', data: JSON.stringify({ attributes: changes }),
      success: function (updated) { lastCart = updated; }
    });
  }

  function refresh() {
    $.getJSON(root() + 'cart.js', function (cart) { lastCart = cart; syncAttributes(cart); });
  }

  // The page carries TWO jQuery copies: the theme's add-to-cart (app.js) runs on window.$, which is NOT
  // window.jQuery, and ajaxComplete only fires on the copy that made the request (verified live
  // 2026-09-30). Listen on each distinct copy; a request fires on exactly one, so nothing doubles.
  function onAjaxComplete(handler) {
    [window.jQuery, window.$].filter(function (jq, i, all) {
      return jq && typeof jq.fn === 'object' && all.indexOf(jq) === i;
    }).forEach(function (jq) { jq(document).ajaxComplete(handler); });
  }

  onAjaxComplete(function (e, xhr, settings) {
    var url = (settings && settings.url) || '';
    if (url.indexOf('/cart') === -1) return;
    if (selfUpdate && url.indexOf('/cart/update') !== -1) { selfUpdate = false; return; }
    if (url.indexOf('/cart.js') !== -1) return; // a read, not a change; refresh() handles its own
    var data = xhr && xhr.responseJSON;

    if (url.indexOf('/cart/add') !== -1 && data && xhr.status < 300) {
      // add.js answers with the added line (or {items:[...]} for a multi-add), not the cart.
      var lines = data.items || [data];
      var cur = currency(lastCart);
      var contents = lines.map(function (l) { return contentOf(l, cur); });
      var amount = lines.reduce(function (s, l) { return s + (l.final_line_price || 0); }, 0);
      measure('measure', 'items_added', { type: 'contents', amount: amount, currency: cur, contents: contents });
    }

    if (data && typeof data.token !== 'undefined' && data.items) { lastCart = data; syncAttributes(data); }
    else refresh();
  });

  // Checkout buttons are plain form submits (cart page) or links (mini-cart); both leave the page, so
  // the SDK's own batching/beacon has to carry the event out.
  $(document).on('click', '[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]', function () {
    var cart = lastCart;
    if (!cart || !cart.item_count) return;
    var cur = currency(cart);
    measure('measure', 'checkout_started', {
      type: 'contents', amount: cart.total_price, currency: cur,
      contents: cart.items.map(function (i) { return contentOf(i, cur); })
    });
  });

  // The pixel snippet announces the consent answer (and every change). Sync then - the pixel has written
  // its cookies by that point - but skip the extra /cart.js read on an empty cart.
  function onConsent() {
    if (lastCart) syncAttributes(lastCart);
    else if (window.__bsfOaiCartCount > 0) refresh();
  }
  document.addEventListener('bsf:oai-consent', function () { setTimeout(onConsent, 500); });
  if (consent() !== undefined) setTimeout(onConsent, 500);
})();
